// extracted by mini-css-extract-plugin
module.exports = {"faceBusiness":"#222","churchCrab":"#e8e4d9","tepidAngst":"#92898a","passiveCrane":"#ede3e4","dyingUrchin":"#cbbbb9","burningHarpy":"#fff","cloningWitch":"#f6f2ec"};